import React, {Component} from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import 'terminal.css'

import Navigator from './Navigator.js';
import {LittleEndian, TrigGraphic} from './Graphics.js';

class Home extends Component{
	render(){
		return(	
			<div className="container">
				<Navigator />
				<main>
					<section>
						<header>
							<h2><LittleEndian>Summary</LittleEndian></h2>
						</header>
						<TrigGraphic/>
						<p>
							I do embedded vulnerability research and reverse engineering. I also like to play CTFs and dabble in data science.
						</p>
						
					</section>
					<hr/>
					<section>
						<header>
							<h2><LittleEndian>Links</LittleEndian></h2>
						</header>
						<Grid>
							<Row>
								<Col sm={12} md={4}>									
									<div className="terminal-card">
										<header>Github</header>
										<div className="card-content">
											<a href="https://github.com/Veryyes">
												<button className="btn btn-default">
													<img src="./images/GitHub-Mark-32px.png" alt="github logo"/>
												</button>
											</a>
											<br/><br/>
											Checkout what I've been working on
										</div>
									</div>
								</Col>
								<Col sm={12} md={4}>
									<div className="terminal-card">
										<header>Linkedin</header>
										<div className="card-content">
											<a href="https://www.linkedin.com/in/brandon-wong-6b31a6106/">
												<button className="btn btn-default">
													<img src="./images/In-2C-48px-R.png" alt="linkedin logo"/>
												</button>
											</a>
											<br/><br/>
											Connect on Linkedin if you know me
										</div>
									</div>
								</Col>
								<Col sm={12} md={4}>
									<div className="terminal-card">
										<header>Debugmen</header>
										<div className="card-content">
											<a href="https://debugmen.dev/">
												<button className="btn btn-default">
													<img src="./images/debugmen.png" alt="bug_with_crosshair" height="32px"/>
												</button>
											</a>
											<br/><br/>
											CTF write ups and tech things by my colleagues and myself
										</div>
									</div>
								</Col>
							</Row>
						</Grid>
					</section>
				</main>
			
			</div>
		);
	}

}

export default Home;
